'use es6';

import styled from 'styled-components';
import { CALYPSO, CALYPSO_DARK } from 'HubStyleTokens/colors';
export default styled.div.withConfig({
  displayName: "CalypsoHandleButtonWrapper",
  componentId: "sc-9liuk6-0"
})([".hs-private.hs-private.hs-private & .uiButton.uiButton{background-color:", ";border:none;}.hs-private.hs-private.hs-private & .uiButton.uiButton:hover{background-color:", ";border:none;}"], CALYPSO, CALYPSO_DARK);